
const m = window.require("velocity");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
